<template>
  <v-card>
    <v-card-title>
      <span class="headline">Add High Demand Items Form</span>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="name"
              label="Name of the High Demand Item"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="caption"
              label="Write a caption for the item"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              v-model="demandRate"
              label="Demand Rate in Percent"
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <date-picker :dateTimeStamp="date" />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <time-picker :TimeStamp="time" />
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <v-text-field
              label="Image link for the high demand Item"
              v-model="imagePath"
              readonly
              required
            ></v-text-field>
          </v-col>
          <v-col cols="12" sm="12" md="12">
            <div class="container upload-image-offset">
              <div class="row justify-content-center">
                <div class="col-12"><image-upload :title="upload" /></div>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
      <small>*indicates required field</small>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="blue darken-1" text @click="this.triggerCloseDialog">
        Close
      </v-btn>
      <v-btn color="blue darken-1" text @click="this.saveHighDemandItem">
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { eventBus } from "@/main.js";
import { mapFields } from "vuex-map-fields";
import { mapActions } from "vuex";
import datePicker from "../shared/components/datePicker";
import timePicker from "../shared/components/timePicker";
import imageUpload from "../shared/components/imageUpload";
import cities from "../shared/constants/cities";

export default {
  components: { datePicker, imageUpload, timePicker },
  computed: {
    ...mapFields("donation", ["allLocations"]),
    ...mapFields("shared", [
      "imagePath",
      "selectedTime",
      "selectedDate",
      "selectedDateTime",
    ]),
  },
  data: () => ({
    name: "",
    caption: "",
    demandRate: "",
    date: null,
    time: null,
    upload: "upload an image",
  }),
  methods: {
    ...mapActions("donation", [
      "selectedDonationCenterId",
      "addHighDemandItem",
    ]),
    ...mapActions("shared", ["setImagePath", "dateTimeSelected"]),
    triggerCloseDialog(value) {
      eventBus.$emit("dialogToggle", false);
    },

    async saveHighDemandItem() {
      // Parse string TimeDate as TimeStamp
      var dateTime = this.selectedDate + " " + this.selectedTime;
      this.dateTimeSelected({
        payload: {
          datetime: dateTime,
        },
      });

      try {
        this.addHighDemandItem({
          payload: {
            centerId: this.$route.params.id,
            demand: {
              name: this.name,
              caption: this.caption,
              demandRate: this.demandRate,
              timestamp: this.selectedDateTime,
              imagePath: this.imagePath,
            },
          },
        });
        eventBus.$emit("dialogToggle", false);
        alert("Successfully Added High Demand Item!");
      } catch (error) {
        alert("Failed to create High demand item!");
      }
    },
  },
};
</script>